import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// Função para criar o validador customizado
export function passwordStrengthValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        if (!value) {
            return null; // Não valida se o campo estiver vazio
        }

        const hasUpperCase = /[A-Z]+/.test(value);
        const hasLowerCase = /[a-z]+/.test(value);
        const hasNumeric = /[0-9]+/.test(value);
        const hasSpecialChar = /[!@#$%&*]+/.test(value);

        const isValid = hasUpperCase && hasLowerCase && hasNumeric && hasSpecialChar;

        return !isValid ? { passwordStrength: true } : null;
    };
}